import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {Container, Table, Header, Menu, Icon, Loader, Segment} from 'semantic-ui-react';
import {FemaGoTable} from 'app-ui-componentlibrary';
import _ from 'lodash';
import {TOTAL} from './constants';
import InfiniteScroll from 'react-infinite-scroll-component';
import {showDollarAmountWithDollar} from 'common/utils';
export class AwardsTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      awards: [],
    };
  }

  render() {
    const {filter, column, direction, awards, mileStoneArray, trackSubGrants, attributes, rankingDirection} = this.props;

    const filterAwards =
      filter != TOTAL
        ? awards.filter((result) => result.state == mileStoneArray[filter])
        : awards;

    const sortedAwards =
      direction != 'descending'
        ? _.sortBy(filterAwards, [column])
        : _.sortBy(filterAwards, [column]).reverse();
        
    const table = sortedAwards.map((result, index) => (
      <FemaGoTable.Row>
        <FemaGoTable.TextCell>
          <Link to={trackSubGrants ? `/subGrant/${result.key}`: `/grant/${result.key}`} target="_blank" title={result.key}>
            {result.key}
          </Link>
        </FemaGoTable.TextCell>
        {_.includes(attributes, "foTrackFundingTarget") ? <FemaGoTable.TextCell>{result.attribute}</FemaGoTable.TextCell> : null}
        {_.includes(attributes, "organizationKind") ? <FemaGoTable.TextCell>{result.organizationInfo}</FemaGoTable.TextCell> : null}
        <FemaGoTable.TextCell>{result.organizationName}</FemaGoTable.TextCell>
        <FemaGoTable.TextCell>{result.orgState}</FemaGoTable.TextCell>
        <FemaGoTable.TextCell>{result.state}</FemaGoTable.TextCell>
        {!_.isEqual(rankingDirection, "NONE") ? <FemaGoTable.TextCell>{result.score}</FemaGoTable.TextCell> : null}
        <FemaGoTable.TextCell>{result.rank}</FemaGoTable.TextCell>
        <FemaGoTable.TextCell>
          {showDollarAmountWithDollar(result.value)}
        </FemaGoTable.TextCell>
      </FemaGoTable.Row>
    ));
    return (
      <Segment>
        <InfiniteScroll
          dataLength={awards.length}
          next={this.props.fetchMoreData}
          hasMore={this.props.hasMore}
          scrollableTarget={'root'}
          loader={
            <Loader inline="centered" active>
              Loading...
            </Loader>
          }
        >
          <FemaGoTable type="static" summary="Award recommendations data table">
            <FemaGoTable.Header>
              <FemaGoTable.Row>
                <FemaGoTable.HeaderCell>ID</FemaGoTable.HeaderCell>
                {_.includes(attributes, "foTrackFundingTarget") ? <FemaGoTable.HeaderCell>Attribute</FemaGoTable.HeaderCell> : null}
                {_.includes(attributes, "organizationKind") ? <FemaGoTable.HeaderCell>{trackSubGrants ? "Suborganization Type" : "Organization Type"}</FemaGoTable.HeaderCell> : null}
                <FemaGoTable.HeaderCell>{trackSubGrants ? "Suborganization Name" : "Organization Name"}</FemaGoTable.HeaderCell>
                <FemaGoTable.HeaderCell>State</FemaGoTable.HeaderCell>
                <FemaGoTable.HeaderCell>Milestone</FemaGoTable.HeaderCell>
                {!_.isEqual(rankingDirection, "NONE") ? <FemaGoTable.HeaderCell>Cumulative score</FemaGoTable.HeaderCell> : null}
                <FemaGoTable.HeaderCell>Priority rank</FemaGoTable.HeaderCell>
                <FemaGoTable.HeaderCell>Fed share</FemaGoTable.HeaderCell>
              </FemaGoTable.Row>
            </FemaGoTable.Header>
            <FemaGoTable.Body>{table}</FemaGoTable.Body>
          </FemaGoTable>
        </InfiniteScroll>
      </Segment>
    );
  }
}
